import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  RouteProps,
} from "react-router-dom";
import "./App.css";
import Application from "./views/app";
import { ViewLoading } from "./views/loading";
import MeaAuth from "./views/auth/mea-auth";
import "react-image-gallery/styles/css/image-gallery.css";
import Activate from "./views/auth/activate";

const Authen = lazy(() => import("./views/auth"));
const Main = lazy(() => import("./views"));
const Profile = lazy(() => import("./views/profile"));
const NotFound404 = lazy(() => import("./views/notfound404"));

interface IRouteProps extends RouteProps {
  component: any;
}

const PrivateRoute = (props: IRouteProps) => {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        localStorage.getItem("token") ? (
          <Suspense fallback={<ViewLoading />}>
            <Component {...routeProps} />
          </Suspense>
        ) : (
          <Redirect
            to={{
              pathname: "/auth",
            }}
          />
        )
      }
    />
  );
};

const SelfRoute = (props: IRouteProps) => {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        localStorage.getItem("token") ? (
          <Redirect
            to={{
              pathname: "/app",
            }}
          />
        ) : (
          <Suspense fallback={<ViewLoading />}>
            <Component {...routeProps} />
          </Suspense>
        )
      }
    />
  );
};

const PublicRoute = (props: IRouteProps) => {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(routeProps) => (
        <Suspense fallback={<ViewLoading />}>
          <Component {...routeProps} />
        </Suspense>
      )}
    />
  );
};

const App = () => {
  return (
    <Router>
      <Switch>
        <PrivateRoute path="/app" component={Application} />
        <SelfRoute path="/auth" component={Authen} />
        <PrivateRoute path="/profile" component={Profile} />
        <Route path="/mea-auth" component={MeaAuth} />
        <Route path="/activate" component={Activate} />
        <PublicRoute path="/" exact component={Main} />

        <PublicRoute path="/404" component={NotFound404} />
        <Redirect to="/404" />
      </Switch>
    </Router>
  );
};

export default App;
